import { Scene, Color, Mesh } from 'three'

export default function useConfigurator3d() {
  let canvas: HTMLCanvasElement
  const scene = new Scene()
  let camera: ReturnType<typeof useCamera>
  let renderer: ReturnType<typeof useRenderer>

  scene.background = new Color('#fff')

  useSizes()

  let wasSet = false

  function destroy() {
    if (!wasSet) return

    scene.traverse((child) => {
      if (child instanceof Mesh) {
        child.geometry.dispose()

        for (const key in child.material) {
          const value = child.material[key]
          if (value && typeof value.dispose === 'function') {
            value.dispose()
          }
        }
      }
    })

    camera.controls.dispose()
    renderer.instance.dispose()
  }

  function setMembers(canvasElement: HTMLCanvasElement) {
    if (!canvasElement) return

    canvas = canvasElement

    camera = useCamera(canvas, scene)
    renderer = useRenderer(canvas, scene)

    useTime()

    // renderer.initProgressiveShadows()
    // const environment = new RoomEnvironment()
    // const pmremGenerator = new PMREMGenerator( renderer.instance );
    // scene.environment = pmremGenerator.fromScene( environment ).texture;
    useWorld(scene)
    wasSet = true
  }

  return {
    setMembers,
    destroy,
    scene,
  }
}
